import React, {Component} from 'react'
import {observer} from 'mobx-react'
import {Spin} from 'antd'
import ErrorBoundary from 'Components/ErrorBoundary'
import Chart from './Chart'

@observer
class MultipleTickers extends Component {
  componentDidMount() {
    this.props.store.fetchPnl(this.props.id)
    this.props.store.fetchTransactions(this.props.id)
  }
  render() {
    const store = this.props.store
    const loading = store.pnl.loading || store.transactions.loading || this.props.loading
    const data = store.multipleTickers
    if (data.length < 2) {
      return null
    }
    if (loading) {
      return (
        <Spin size='large'>
          <div style={{width: '100%', minHeight: 250, height: '100%'}}/>
        </Spin>
      )
    }
    return(
      <ErrorBoundary>
        <Chart
          pnlFailed={store.pnl.failed}
          transactionsFailed={store.transactions.failed}
          data={data.slice()}
          style={{margin:'20px 0'}}
          timeFormat={store.labelFormat}
        />
      </ErrorBoundary>
    )
  }
}

export default MultipleTickers
